module.exports = __webpack_public_path__ + "static/sunrise-labels-6a8f102da02f729cf9fa3cb22f92ea78.jpg";